<template>
  <div>
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    >
      <el-form style="margin-top: 20px">
        <el-form-item label="部位名称">
          <el-input placeholder="请输入部位名称" style="width: 200px;" v-model="partValue"></el-input>
          <el-button type="primary" style="float: right" @click="partSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    </top-bar>

    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination @sizePageChange="paginationChangeProduct" :paginationDatas="paginationDataProduct">
    </pagination>
    <modal
      :isShow.sync="dialogShowLabel"
      title="新增"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="部位名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="10"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow="dialogShowEditLabel"
      title="编辑"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="editClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="部位名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="10"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>

    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import topBar from "@/components/topBar"
import baseTable from "@/components/baseTable"
import breadCrumb from "@/components/breadCrumb"
import modal from "@/components/modal"
import {
  newPartLabel,
  modifyPartLabel,
  deletePartLabel,
  queryPartLabel
} from "@/api/man.js"

export default {
  name: "partGroup",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        callback()
      }
    }
    return {
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: 'ID',
            prop: 'id'
          },
          {
            label: '部位',
            prop: 'name'
          },
          {
            label: '创建时间',
            prop: 'createTime'
          },
        ],
        tableType: 5
      },
      isShowSelect: false,
      // 删除弹框
      deleteDialog: false,
      data: [],
      tableVal: {},
      btnText: ["取消", "确认"],
      isShowBtn: [true, true, false],
      nameValue: "",
      dialogShow: false,
      dialogShowLabel: false,
      dialogShowEditLabel: false,
      labelInfos: null,
      formList: {
        nameValue: "",
        nameType: "",
      },
      rules: {
        nameValue: [
          {validator: validatePass, trigger: 'blur'}
        ],
      },
      partValue: ''
    }
  },
  components: {
    baseTable,
    topBar,
    breadCrumb,
    modal,
    pagination
  },

  methods: {
    // 获取部位标签数据以及模糊查询部位名字
    async pageContentLabelsByGroupId(val) {
      let res = await queryPartLabel({
        tenantId: this.$commonJs.getTenantId(),
        name: val,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize
      })
      sessionStorage.setItem('groupID', this.$route.query.id)
      this.tableData.tableList.splice(0, this.tableData.tableList.length)
      const {totalCount, pageNo, pageSize} = res
      this.paginationDataProduct.total = totalCount
      this.paginationDataProduct.currentPage = pageNo
      this.paginationDataProduct.pageSize = pageSize
      res.data.map(item => {
        this.tableData.tableList.push(item)
      })
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.pageContentLabelsByGroupId()
    },
    // 操作按钮-编辑和删除
    handleClick(val) {
      if (val.type === 'edit') {
        this.dialogShowEditLabel = true
        this.formList.nameValue = val.val.name
        this.editLabelName(val)

      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.tableVal = val.val
      }
    },
    // 删除弹窗
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.deleteLabelGroupById(this.tableVal)
      }
    },
    // 删除部位标签
    deleteLabelGroupById(val) {
      deletePartLabel({
        tenantId: this.$commonJs.getTenantId(),
        id: val.id
      })
        .then(res => {
          console.log(res, '删除')
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.deleteDialog = false
          this.paginationDataProduct.currentPage = 1;
          this.pageContentLabelsByGroupId();
        })
        .catch(res => {
          this.$message.error(res.msg)
        })
    },
    // 部位标签新增
    addClickHandler(val) {
      // 取消
      if (val === 'one') {
        this.dialogShowLabel = false
        // 确定
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          // 添加标签
          newPartLabel({
            tenantId: this.$commonJs.getTenantId(),
            name: this.formList.nameValue,
          }).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogShowLabel = false
            this.pageContentLabelsByGroupId();
          }).catch(res => {
            this.$message.error(res.msg)
          })
        } else {
          this.$message.error('请输入部位标签名称')
        }

      }
    },
    // 编辑赋值
    editLabelName(target) {
      this.labelInfos = target.val
    },
    // 编辑
    editClickHandler(val) {
      // 取消
      if (val === 'one') {
        this.dialogShowEditLabel = false
        // 确定
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          modifyPartLabel({
            tenantId: this.$commonJs.getTenantId(),
            id: this.labelInfos.id,
            name: this.formList.nameValue
          }).then(res => {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
            this.dialogShowEditLabel = false
            this.pageContentLabelsByGroupId();
          }).catch(res => {
            this.$message.error(res.msg)
          })
        } else {
          this.$message.error('请输入部位标签名称')
        }

      }
    },
    // 查询名字
    partSearch() {
      this.paginationDataProduct.currentPage = 1;
      this.pageContentLabelsByGroupId(this.partValue)
    },
    clickAddButton() {
      this.formList.nameValue = ''
      this.dialogShowLabel = true
    },
    handleDialog(val) {
      this.dialogShow = val
    },
    handleDialogLabel(val) {
      this.dialogShowLabel = val
      this.dialogShowEditLabel = val
    },
    handleDialogSubmit() {
      this.handleDialog(false)
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false)
    },
  },
  created() {
    this.pageContentLabelsByGroupId()
  }
};
</script>

<style lang="scss" scoped>

.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}
</style>
